<template>
    <div id="areaMsg">
        <top :title="title"></top>
        <div class="setFix"></div>
        <form action="">
            <mt-field label="省份" v-model="community.pname" disabled></mt-field>
            <mt-field label="城市" v-model="community.cityname" disabled></mt-field>
            <mt-field label="区县" v-model="community.adname" disabled></mt-field>
            <mt-field label="具体位置" v-model="community.address" disabled></mt-field>
            <mt-field label="小区名称" v-model="community.community" disabled></mt-field>
        </form>
        <div class="footBox">
            <p>小区住户扫描下方二维码即可完成进门登记</p>
            <div class="timg">
                <img :src="imgSrc" alt="">
                <canvas id="QRCode"></canvas>
            </div>
            <p class="out">进门码</p>
            <div class="timg">
                <img :src="imgSrc2" alt="">
                <canvas id="QRCode2"></canvas>
            </div>
            <p class="out">出门码</p>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Top from "@/component/top/top";
import { MessageBox, Toast } from 'mint-ui';
import QRCode from "qrcode";
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'小区信息',
            imgSrc:'',
            imgSrc2:'',
            community:{
                pname:'',
                cityname:'',
                adname:'',
                address:'',
                community:'',
                poiId:''
            }
        }
    },
    created() {

    },
    mounted() {
        this.getDetail()
        // 进门
        this.QRCodeMsg(this.commonIp()+`/htmls/community/#/pcheck?state=1&poiId=${this.$route.query.poiId}`)
        // 出门
        this.QRCodeMsg2(this.commonIp()+`/htmls/community/#/pcheck?state=2&poiId=${this.$route.query.poiId}`)
    },
    methods:{
        getDetail() {
            axios.get(this.commonIp()+`/v1/mobile/community/info?poiId=${this.$route.query.poiId}`)
                .then((res) => {
                    if(res.data.code == '200') {
                        this.community  = res.data.data.community
                    }
                })
        },
        QRCodeMsg(val) {
            // 获取页面的canvas
            var canvas = document.getElementById("QRCode");
            var _this = this
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(canvas, val, function(error) {
                if(!error) {
                    _this.imgSrc = canvas.toDataURL("image/png")
                }
            });
        },
        QRCodeMsg2(val) {
            // 获取页面的canvas
            var canvas = document.getElementById("QRCode2");
            var _this = this
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(canvas, val, function(error) {
                if(!error) {
                    _this.imgSrc2 = canvas.toDataURL("image/png")
                }
            });
        }
    }
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    .mint-msgbox-confirm{
        color:#23b355;
        border-left:1px solid #eee;
    }
    #areaMsg{
        #QRCode,#QRCode2{
            display:none;
        }
        .setFix{
            border:0;
        }
        .mint-msgbox-header{
            display: none !important;
        }
        .mint-cell{
            border-top:1px solid #eee;
            .mint-cell-wrapper{
                background-image:none;
            }
            .mint-field-core{
                background:#fff;
                text-align: right;
            }
            &:last-child{
                background-image:none;
                border-bottom:1px solid #eee;
            }
            .mint-cell-value{
                font-size:@ft14;
            }
        }
        .footBox{
            text-align: center;
            p{
                margin:35px 0 20px 0;
                &.out{
                    margin:12px 0;
                }
            }
            .timg{
                margin-top:10px;
                img{
                    width:50%;
                    border:1px solid #eee;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/areamsg/areamsg.vue